import { createContext } from 'preact';

const Context = createContext();

export default Context;
